import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
  Output,
  TemplateRef,
  ViewContainerRef,
  SimpleChanges,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RefreshGridService } from '../../../../../shared/services/refresh-grid.service'; // Import the shared service
import { RequestStatusEnum } from '../../../../../enums/requestStatusEnum';
import {
  GridModule,
  CellClickEvent,
  DataBindingDirective,
} from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { Border, ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
  SelectEvent,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupService, PopupRef } from '@progress/kendo-angular-popup'
import {
  starIcon,
  checkCircleIcon,
  envelopIcon,
  plusIcon,
  eyeIcon,
  minusIcon,
  starOutlineIcon,
  cancelCircleIcon,
  brightnessContrastIcon,
  searchIcon,
  playIcon,
} from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';

import { CommonModule } from '@angular/common';
import { Input, ElementRef } from '@angular/core';
import { PopupModule, Align, AnimationDirection, AnimationType, PopupAnimation } from '@progress/kendo-angular-popup';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SaveUserRequestDetailRequest } from '../../../../../models/request/engagement-user-request/saveUserRequestDetailRequest.model';
import { ShownotificationService } from '../../../../../services/shownotification.service';
import { UserrequestService } from '../../../../../services/userrequest.service';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-request-add-user-activity-panel',
  standalone: true,
  templateUrl: './request-add-user-activity-panel.component.html',
  styleUrl: './request-add-user-activity-panel.component.scss',
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    CommonModule,
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    CommonModule,
    NgxSpinnerModule
  ],
})
export class RequestAddUserActivityPanelComponent {
  @Input() openUserAddPopup!: boolean;
  @Input() public userDetail: any;
  @Input() public selectedRequestId: any;
  @Input() anchor!: any;
  @Input() requestStatus!: string;
  @Input() isApprovalUser: boolean = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() requestUserAddButtonEvent = new EventEmitter<void>();
  public userProfile: any;

  isEngagementApproveFlag = false;
  isUserApproveFlag = false;
  message: string = '';
  public isDisplayloader: boolean = false;

  @ViewChild('popupContent') popupContent!: TemplateRef<any>;

  public userAddRequestForm!: FormGroup;
  public selectedEngagementDetail: any;
  public selectedEngagementNumber: string = "";
  public searchedEngagementDetails: any[] = [];
  public RequestStatusEnum = RequestStatusEnum;

  private popupRef: PopupRef | undefined;

  public searchIcon: SVGIcon = searchIcon;
  public playIcon: SVGIcon = playIcon;


  public enabled = true;
  public duration = 200;
  public type: AnimationType = "slide";
  public direction: AnimationDirection = "left";
  public margin = { horizontal: -30, vertical: -75 };

  public anchorAlign: Align = { horizontal: "right", vertical: "top" };
  public popupAlign: Align = { horizontal: "right", vertical: "top" };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }

  private readonly UserrequestService = inject(UserrequestService);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly refreshGridService = inject(RefreshGridService);
  private spinner = inject(NgxSpinnerService);

  ngOnChanges(changes: SimpleChanges) {
    this.spinner.show();
    if (changes['userDetail']) {
       this.message="";
      if (this.requestStatus === RequestStatusEnum.Pending && !this.isApprovalUser) {
        this.message = 'Request is Pending';
      } else if (this.requestStatus === RequestStatusEnum.Approved && this.isApprovalUser) {
        this.message = 'Already Approved';
      } else if (this.requestStatus === RequestStatusEnum.Rejected) {
        this.message = 'Already Rejected';
      } else if (this.requestStatus === RequestStatusEnum.Completed) {
        this.message = 'Already Completed';
      }

      if (this.userDetail) {
        this.setUserAddRequestFormValues();
        this.userDetail.activityStream = [{ description: this.userDetail.requestUserComment, date: new Date(this.userDetail.requestedOn), title: this.userDetail.requestUserDisplayName, subtitle: 'Requester' }];
         if (!(this.isApprovalUser && (this.requestStatus === RequestStatusEnum.Pending))) {
          this.userDetail.activityStream.push({ description: this.userDetail.approvalUserComment, date: new Date(this.userDetail.approvedUserActionedOn), title: this.userDetail.approvalUserDisplayName, subtitle: 'Approver' });
          if (this.requestStatus === RequestStatusEnum.Completed) {
            this.userDetail.activityStream.push({ description: this.userDetail.supportUserComment, date: new Date(this.userDetail.completedOn), title: this.userDetail.supportUserDisplayName, subtitle: 'Support User' });
          }
        }
      } else {
        this.isDisplayloader = true;
        this.spinner.show();
      }
    }
  }

  ngOnInit(): void {
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? "");
    this.createUserAddRequestForm();
    this.isDisplayloader = true;
    this.spinner.show();
    if (this.userDetail) {
      this.setUserAddRequestFormValues();
    }
  }

  handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }



  public open(): void {
    this.openUserAddPopup = true;
    this.resetUserAddRequestForm();


  }

  public close(): void {
    this.openUserAddPopup = false;
    this.closeEvent.emit();
    this.resetUserAddRequestForm();


  }


  public onFilter(value: Event): void {
    const inputValue = value;
  }

  public resetUserAddRequestForm(): void {
    //  this.name = '';
    //  this.accountId = '';
    //  if (this.form) {
    //    this.form.resetForm();
    //  }
  }

  public createUserAddRequestForm(): void {
    this.userAddRequestForm = this.fb.group({
      createdDate: [null],
      createdBy: [null],
      modifiedDate: [null],
      modifiedBy: [null],
      userRequestId: [null],
      requestId: [null],
      engagementId: [null],
      engagementName: [null],
      Name: [null],
      userId: [null],
      UserRequestRoleTypeId: [null],
      userEmail: [null],
      approvalUserId: [null],
      approvalUserEmail: [null],
      approvalUserComment: [null],
      supportUserId: [null],
      supportUserEmail: [null],
      supportUserComment: [null],
    });

  }

  public setUserAddRequestFormValues() {
    if (this.userDetail && this.userAddRequestForm) {
      this.userAddRequestForm.setValue({
        createdDate: this.userDetail.createdDate,
        createdBy: this.userDetail.createdBy,
        modifiedDate: this.userDetail.modifiedDate,
        modifiedBy: this.userDetail.modifiedBy,
        userRequestId: this.userDetail.userRequestId,
        requestId: this.selectedRequestId,
        engagementId: this.userDetail.engagementId,
        engagementName: this.userDetail.engagementName,
        Name: this.userDetail.name,
        userId: this.userDetail.userId,
        UserRequestRoleTypeId: this.userDetail.userRequestRoleTypeId,
        userEmail: this.userDetail.userEmail,
        approvalUserId: this.isApprovalUser ? this.userProfile.id : this.userDetail.approvalUserId,
        approvalUserEmail: this.isApprovalUser ? this.userProfile.email : this.userDetail.approvalUserEmail,
        supportUserId: !this.isApprovalUser ? this.userProfile.id : null,
        supportUserEmail: !this.isApprovalUser ? this.userProfile.email : null,
        approvalUserComment: '',
        supportUserComment: ''
      });
      this.isDisplayloader = false;
      this.spinner.hide();
    }
  }

  public resetForm(): void {
    this.userAddRequestForm.reset();
  }

  public approveUserRequest(): void {

    if (this.userAddRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isUserApproveFlag = true;
      this.UserrequestService.approveOrDenyUserRequestDetails(this.userAddRequestForm.value, this.selectedRequestId, this.isUserApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('successUsertState');
          //this.approveOrDenyUserButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        }
      });
    }

  }

  public denyUserRequest(): void {

    if (this.userAddRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isUserApproveFlag = false;
      this.UserrequestService.approveOrDenyUserRequestDetails(this.userAddRequestForm.value, this.selectedRequestId, this.isUserApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('denyUserState');
          //this.approveOrDenyUserButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        }
      });
    }

  }

  public addUserRequest(): void {
    if (this.userAddRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      const userDetail: SaveUserRequestDetailRequest = {
        userRequestId: 0,
        requestId: this.userAddRequestForm.get('requestId')?.value,
        engagementId: this.userAddRequestForm.get('engagementId')?.value,
        userId: this.userAddRequestForm.get('userId')?.value,
        name: this.userAddRequestForm.get('Name')?.value,
        userEmail: this.userDetail.userEmail,
        RequestUserId: this.userDetail.requestUserId,
        RequestUserEmail: this.userDetail.requestUserEmail,
        RequestUserComment: null,
        ApprovalUserId: null,
        ApprovalUserEmail: null,
        ApprovalUserComment: null,
        userRequestRoleTypeId: this.userAddRequestForm.get('UserRequestRoleTypeId')?.value,
        SupportUserId: this.userProfile.id,
        SupportUserEmail: this.userProfile.email,
        SupportUserComment: this.userAddRequestForm.get('supportUserComment')?.value,
      };
      this.UserrequestService.addUserDetail(userDetail, userDetail.requestId).subscribe({
        next: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
          this.shownotificationService.showNotification('addUserSuccess');
          //this.addUserButtonEvent.emit();
          this.refreshGridService.refreshRequestGrid.next(true);
          if (this.requestStatus === RequestStatusEnum.Completed) {
            this.userAddRequestForm.get('supportUserComment')?.disable();
          }
        },
        error: (error) => {

          var errorResult = JSON.parse(error.error);
          if (errorResult.StatusCode == "500") {
            this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Internal Server Error")
          }
          else if (errorResult.StatusCode == "503") {
            this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Service Unavailable")
          }
          else {
            this.shownotificationService.showNotification("addUserError", errorResult.ErrorMessage);
          }
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        },
      });
      //if((clientCode !=null || clientCode !="") &&  (clientName!=null || clientName !="")){
      //  this.engagementService.createEngagementRequestDetails(this.engagementRequestDetailsForm.value).subscribe(_ => {

      //   this.shownotificationService.showNotification('success');
      //   this.router.navigate([
      //     '/RequestEngagementSuccess',
      //     this.selectedEngagementDetail.engagementName
      //   ]);
    }
  }

  public cancelUserRequest(): void {
    this.close();
  }

}





